module.exports = __webpack_public_path__ + "img/our-work-06.71015d38.jpg";